import $ from "jquery";

//******************************************************************************************//
//              //
//    Bilety    //
//              //
//******************************************************************************************//

function wiCreateCookie(name, value, days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + date.toGMTString();
  } else {
    var expires = "";
  }
  if (value != "") {
    document.cookie = name + "=" + value + expires + "; path=/";
  }
  // console.log(document.cookie)
}
function wiDeleteCookie(name) {
  var date = new Date();
  date.setTime(date.getTime() - 24 * 60 * 60 * 1000);
  var expires = "; expires=" + date.toGMTString();
  document.cookie = name + "=" + expires + "; path=/";
}
function wiGetCookie(name) {
  name = name + "=";
  var cArr = window.document.cookie.split(";");
  for (var i = 0; i < cArr.length; i++) {
    var c = cArr[i].trim();
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}

// URL
if (window.location.origin == "http://localhost") {
  var wi_domain = "http://localhost/twinpigs";
} else {
  var wi_domain = window.location.origin;
}

// List add
var load_add = function(shop_id, quantity) {
  $.ajax({
    url: teik.ajax_url,
    type: "POST",
    // action: ,
    dataType: "html",
    data: {
      shop_id: shop_id,
      quantity: quantity,
      action: "add",
    },
    success: function(data) {
      console.log("Dodawanie ajax działa");
      $('.tickets__single__quantity input.in-num').val(1);
      // var key = data.substring(0, data.length -1);
      // console.log(key)
      if (data.length == 26) {
        if (wiGetCookie("symfony") == data) {
          window.sessionStorage.setItem("dialogshow", "not");
          if (sessionStorage["dialogshow"] != "yes") {
            setTimeout(function() {
              $(".sectionCartPopupHelp").addClass("sectionCartPopupOpen");
              sessionStorage["dialogshow"] = "yes";
              //  return false;
            }, 60000);
          }

          $("#WidgetTicketCount").text(
            parseInt($("#WidgetTicketCount").text()) + parseInt(quantity)
          );
          $(".sectionCartPopup").addClass("sectionCartPopupOpen");
        } else {
          wiCreateCookie("symfony", data);
          $("#WidgetTicketCount").text("1");
          $(".sectionCartPopup").addClass("sectionCartPopupOpen");
        }
      } else {
        $(".sectionCartPopupError").addClass("sectionCartPopupOpen");
      }
    },
  });
};
// wiCreateCookie("symfony");
var load_add_multiple = function() {
  var submitform = $("#group_tickets_form").serialize();
  let ticket_1_qty = $('input[name="group_tickets[64][quantity]"]').val();
  let ticket_2_qty = $('input[name="group_tickets[65][quantity]"]').val();
  let ticket_3_qty = $('input[name="group_tickets[55][quantity]"]').val();

  let tickets_qty = parseInt(ticket_1_qty) + parseInt(ticket_2_qty) + parseInt(ticket_3_qty);
  $.ajax({
    url: teik.ajax_url,
    type: "POST",
    // action: ,
    dataType: "html",
    data: {
      // shop_id : shop_id,
      // quantity : quantity,
      submitform: submitform,
      action: "add_multiple",
    },
    success: function(data) {
      console.log("Dodawanie ajax działa");
      $('#group_tickets_form input.in-num').val(0);
      // var key = data.substring(0, data.length -1);
      console.log(data);
      if (data.length == 26) {
        if (wiGetCookie("symfony") == data) {
          $("#WidgetTicketCount").text(
            parseInt($("#WidgetTicketCount").text()) + tickets_qty
          );
          $(".sectionCart span").text(
            parseInt($(".sectionCart span").text()) + 1
          );
          $(".sectionCartPopup").addClass("sectionCartPopupOpen");
        } else {
          wiCreateCookie("symfony", data);
          $(".sectionCart span").text("1");
          $(".sectionCartPopup").addClass("sectionCartPopupOpen");
        }
      } else {
        $(".sectionCartPopupError").addClass("sectionCartPopupOpen");
      }
    },
  });
};

// create cookie at first click widget
var load_add_multiple_cookie = function(shop_id, quantity) {
  $.ajax({
    url: teik.ajax_url,
    type: "POST",
    // action: ,
    dataType: "html",
    data: {
      shop_id: shop_id,
      quantity: quantity,
      action: "add_cookie",
    },
    success: function(data) {
      console.log("Dodawanie ajax działa");
      // var key = data.substring(0, data.length -1);
      // console.log(key)
      if (data.length == 26) {
        if (wiGetCookie("symfony") == data) {
          $("#WidgetTicketCount").text(
            parseInt($("#WidgetTicketCount").text()) + 1
          );
          // $(".sectionCartPopup").addClass("sectionCartPopupOpen");
        } else {
          wiCreateCookie("symfony", data);
          $("#WidgetTicketCount").text("1");
          // $(".sectionCartPopup").addClass("sectionCartPopupOpen");
        }
      } else {
        $(".sectionCartPopupError").addClass("sectionCartPopupOpen");
      }
    },
  });
};

// Delete
var load_del = function(cart_id) {
  $.ajax({
    url: teik.ajax_url,
    type: "POST",
    dataType: "html",
    data: {
      cart_id: cart_id,
      action: "del",
    },
    beforeSend: function() {
      $("#sectionLoader").show();
    },
    complete: function() {
      // $('#sectionLoader').hide();
      location.reload();
    },
    success: function(data) {
      console.log("Usuwanie ajax działa");
      // window.location = '/twinpigs/koszyk/#loaded';

      // location.reload();
    },
    error: function() {
      // window.location = '/twinpigs/koszyk/#loaded';
      location.reload();
    },
  });
};

// next payment
var load_next = function() {
  $.ajax({
    url: teik.ajax_url,
    type: "POST",
    dataType: "html",
    data: {
      // cart_id : cart_id,
      // city: $(".UserInfo.City").val(),
      payment_type: $("[name=payment_method]:checked").val(),
      delivery: $("[name=delivery]:checked").val(),
      action: "redirect",
    },
    success: function() {
      // console.log('Usuwanie ajax działa')
      sessionStorage.setItem(
        "payment_type",
        $("[name=payment_method]:checked").val()
      );
      sessionStorage.setItem("delivery", $("[name=delivery]:checked").val());
      window.location = wi_domain + "/koszyk/dostawa-i-platnosc";
      // location.reload()
    },
    error: function() {
      // window.location = '/twinpigs/koszyk/#loaded';
      location.reload();
    },
  });
};

// next checkout
var load_next_checkout = function() {
  $.ajax({
    url: teik.ajax_url,
    type: "POST",
    dataType: "html",
    data: {
      email: $(".UserInfo.Email").val(),
      email2: $(".UserInfo.Email2").val(),
      name: $(".UserInfo.Name").val(),
      surname: $(".UserInfo.Surname").val(),
      postcode: $(".UserInfo.PostCode").val(),
      city: $(".UserInfo.City").val(),
      // payment_type: $("[name=payment_method]:checked").val(),
      // delivery: $("[name=delivery]:checked").val(),
      symfony: wiGetCookie("symfony"),
      action: "redirect",
    },
    success: function(data) {
      // console.log('Usuwanie ajax działa')
      // console.log(data);
      sessionStorage.setItem("name", $(".UserInfo.Name").val());
      sessionStorage.setItem("email", $(".UserInfo.Email").val());
      sessionStorage.setItem("email2", $(".UserInfo.Email2").val());
      sessionStorage.setItem("surname", $(".UserInfo.Surname").val());
      sessionStorage.setItem("postcode", $(".UserInfo.PostCode").val());
      sessionStorage.setItem("city", $(".UserInfo.City").val());
      // sessionStorage.setItem("postcode", $(".UserInfo.PostCode").val())

      window.location = wi_domain + "/koszyk/podsumowanie";
      // location.reload()
    },
    error: function() {
      // window.location = '/twinpigs/koszyk/#loaded';
      location.reload();
    },
  });
};

//update
var load_update = function(shop_id, quantity, cart_id) {
  $.ajax({
    url: teik.ajax_url,
    type: "POST",
    dataType: "html",
    data: {
      shop_id: shop_id,
      quantity: quantity,
      cart_id: cart_id,
      action: "update",
    },
    success: function(data) {
      console.log("update ajax działa");
      // window.location = '/twinpigs/koszyk/#loaded';
      location.reload();
    },
    error: function() {
      // window.location = '/twinpigs/koszyk/#loaded';
      location.reload();
    },
  });
};

//checkout
var load_checkout = function(shop_id, quantity, cart_id) {
  $.ajax({
    url: teik.ajax_url,
    type: "POST",
    dataType: "html",
    data: {
      shop_id: shop_id,
      quantity: quantity,
      cart_id: cart_id,
      email: $(".UserInfo.Email").val(),
      email2: $(".UserInfo.Email2").val(),
      name: $(".UserInfo.Name").val(),
      surname: $(".UserInfo.Surname").val(),
      postcode: $(".UserInfo.PostCode").val(),
      city: $(".UserInfo.City").val(),
      payment_type: $("[name=payment_method]:checked").val(),
      delivery: $("[name=delivery]:checked").val(),
      symfony: wiGetCookie("symfony"),
      action: "checkout",
    },
    success: function(data) {
      // console.log('update ajax działa')
      window.location = "/twinpigs/koszyk/podsumowanie";
      // location.reload()
    },
    error: function() {
      window.location = "/twinpigs/koszyk/podsumowanie";
      // location.reload()
    },
  });
};

// console.log(window.location.pathname)
if (window.location.pathname === "/koszyk/podsumowanie/") {
  // var session = sessionStorage.getItem('result');

  // console.log(sessionStorage.getItem(result.name))
  $("#inputName").val(sessionStorage.getItem("name"));
  $("#inputEmail").val(sessionStorage.getItem("email"));
  $("#inputRepeatEmail").val(sessionStorage.getItem("email2"));
  $("#inputSurname").val(sessionStorage.getItem("surname"));
  $("#inputPostCode").val(sessionStorage.getItem("postcode"));
  $("#inputCity").val(sessionStorage.getItem("city"));
  $("#radioDelivers").val(sessionStorage.getItem("city"));
  $("#inputCity").val(sessionStorage.getItem("city"));

  // if (window.sessionStorage.getItem("result") != null) {

  // }
}

// Buy
var load_buy = function() {
  $.ajax({
    url: teik.ajax_url,
    type: "POST",
    dataType: "xml",
    data: {
      email: $(".UserInfo.Email").val(),
      email2: $(".UserInfo.Email2").val(),
      name: $(".UserInfo.Name").val(),
      surname: $(".UserInfo.Surname").val(),
      postcode: $(".UserInfo.PostCode").val(),
      city: $(".UserInfo.City").val(),
      payment_type: 1,
      delivery: $("[name=delivery]:checked").val(),
      symfony: wiGetCookie("symfony"),
      action: "buy",
    },
    success: function(data) {
      console.log("Kupienie ajax daział");
      data = $(data).find("order");
      console.log(data);
      // alert(data);
      // return false;
      // xhr.abort()
      if (data.length > 0) {
        if (data.attr("payed") == "1") {
          $("#for_submit").attr("action", wi_domain + "/podziekowanie/");
        } else {
          console.log("payed = 0");
          $("#for_submit").attr(
            "action",
            "https://secure.przelewy24.pl/index.php"
          );
          $("#for_submit").append(
            $('<input type="hidden" />')
              .attr("name", "p24_session_id")
              .val(data.attr("id"))
          );
          $("#for_submit").append(
            $('<input type="hidden" />')
              .attr("name", "p24_id_sprzedawcy")
              .val("91583")
          );
          $("#for_submit").append(
            $('<input type="hidden" />')
              .attr("name", "p24_kwota")
              .val(data.attr("raw_amount"))
          );
          $("#for_submit").append(
            $('<input type="hidden" />')
              .attr("name", "p24_opis")
              .val("Bilety")
          );
          $("#for_submit").append(
            $('<input type="hidden" />')
              .attr("name", "p24_klient")
              .val(
                data
                  .find("customer")
                  .find("name")
                  .text() +
                  " " +
                  data
                    .find("customer")
                    .find("surname")
                    .text()
              )
          );
          $("#for_submit").append(
            $('<input type="hidden" />')
              .attr("name", "p24_email")
              .val(
                data
                  .find("customer")
                  .find("email")
                  .text()
              )
          );
          $("#for_submit").append(
            $('<input type="hidden" />')
              .attr("name", "p24_adres")
              .val(
                data
                  .find("customer")
                  .find("street")
                  .text()
              )
          );
          $("#for_submit").append(
            $('<input type="hidden" />')
              .attr("name", "p24_kod")
              .val(
                data
                  .find("customer")
                  .find("zip")
                  .text()
              )
          );
          $("#for_submit").append(
            $('<input type="hidden" />')
              .attr("name", "p24_miasto")
              .val(
                data
                  .find("customer")
                  .find("city")
                  .text()
              )
          );
          $("#for_submit").append(
            $('<input type="hidden" />')
              .attr("name", "p24_return_url_ok")
              .val(wi_domain + "/podziekowanie/")
          );
          $("#for_submit").append(
            $('<input type="hidden" />')
              .attr("name", "p24_return_url_error")
              .val(wi_domain + "/blad-platnosci/")
          );
        }
        wiDeleteCookie("symfony");
        $("#for_submit").submit();
      } else {
        // alert(data);
        // return false;
        window.location = wi_domain + "/blad-platnosci/";
      }
    },
    error: function(data) {
      // console.log(JSON.stringify(data));
      window.location = +"/blad-platnosci/";
    },
  });
};

// Walidacja
function validate() {
  $(".validate_err").removeClass("validate_err_open");
  $(".validate_err_post_code").removeClass("validate_err_open");
  $(".validate_err_email").removeClass("validate_err_open");
  $(".validate_err_email2").removeClass("validate_err_open");
  $(".validate_err_accept").removeClass("validate_err_open");
  var requireds = $(".required");
  var err = 0;
  requireds.each(function() {
    if ($(this).hasClass("r_email")) {
      var email = $(this);
      var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (!filter.test(email.val())) {
        $(".validate_err_email", $(this).parent()).addClass(
          "validate_err_open"
        );
        email.focus;
        err++;
      }
    } else if ($(this).hasClass("r_zip")) {
      var post_code = $(this);
      var filter = /^[0-9]{2}\-[0-9]{3}$/;
      if (!filter.test(post_code.val())) {
        $(".validate_err_post_code", $(this).parent()).addClass(
          "validate_err_open"
        );
        post_code.focus;
        err++;
      }
    } else if ($(this).hasClass("r_accept")) {
      if (!$(this).prop("checked")) {
        $(
          ".validate_err_accept",
          $(this)
            .parent()
            .parent()
        ).addClass("validate_err_open");
        err++;
      }
    } else {
      if ($(this).val() == "") {
        $(".validate_err", $(this).parent()).addClass("validate_err_open");
        err++;
      }
    }
  });

  if ($(".Email").val() != $(".Email2").val()) {
    $(".validate_err_email2", $(".Email2").parent()).addClass(
      "validate_err_open"
    );
    err++;
  }

  if (err == 0) {
    return true;
  } else {
    return false;
  }
}

$(".addAction").click(function(e) {
  e.preventDefault();
  var $input = $(this)
    .parents(".tickets__single__wrapper")
    .find("input.in-num")
    .val();
  console.log($input);
  load_add($(this).attr("shop_id"), $input);
});

$(".wti__button").click(function(e) {
  e.preventDefault();
  // if (wiGetCookie("symfony")) {

  // }

  if (wiGetCookie("symfony").length > 0) {
    // $(".sectionCartPopup").addClass("sectionCartPopupOpen");
    if($('.wti__button').hasClass('wti__button--disabled')) {

    } else {
      load_add_multiple();
    }
    $('.wti__button').addClass('wti__button--disabled');
    setTimeout(() => {
        $('.wti__button').removeClass('wti__button--disabled');
    }, 1000);
    $(".sectionCartPopup").addClass("sectionCartPopupOpen");
  }
  // load_add_multiple();
});

// $('.ticket__button--update a').click(function(e){
//     e.preventDefault();
//     load_add($('.sectionCartItemsBox tr').attr('shop_id'));
// });

$(".sectionCartPopup").on("click", function(e) {
  $(this).removeClass("sectionCartPopupOpen");
});
$(".sectionCartPopupHelp").on("click", function(e) {
  $(this).removeClass("sectionCartPopupOpen");
});
$(".sectionCartPopupError").on("click", function(e) {
  $(this).removeClass("sectionCartPopupOpen");
});

$(".sectionItemsDelete").on("click", function(e) {
  load_del($(this).attr("cart_id"));
});

$(".buttonNext").on("click", function(e) {
  load_next();
});

$(".buttonNextCheckout").on("click", function(e) {
  console.log('click detect');
  if (validate()) {
    if (!$(this).hasClass("disabled")) {
      // $(".buttonNextCheckout").addClass("disabled");
      load_next_checkout();
    }
  }
});

// $('.num-in span').on( "click", function(e) {
//     var defaultCount = 1;
//     var $input = parseInt(defaultCount) - parseInt($(this).parents('.num-block').find('input.in-num').val());
//     var $click = $(this).parents('.num-block').find('.minus');
//     var $cart_id = $(this).parents('.num-block').find('.minus').attr('cart_id');
//     console.log($cart_id);
//     e.preventDefault();
//     load_update($($click).attr('shop_id'), $input, $cart_id);
// });

$(".num-in span").on("click", function(e) {
  // console.log($(this).parents('.num-block'))
  e.preventDefault();
  if (e.target.className == "plus") {
    var defaultCount = 1;
    var $input =
      parseInt(defaultCount) +
      parseInt(
        $(this)
          .parents(".num-block")
          .find("input.in-num")
          .val()
      );
    var $click = $(this)
      .parents(".num-block")
      .find(".plus");
    var $cart_id = $(this)
      .parents(".num-block")
      .find(".minus")
      .attr("cart_id");
    e.preventDefault();
    load_update($($click).attr("shop_id"), $input, $cart_id);
  } else {
    var defaultCount = 1;
    var $input =
      parseInt(
        $(this)
          .parents(".num-block")
          .find("input.in-num")
          .val()
      ) - parseInt(defaultCount);
    var $click = $(this)
      .parents(".num-block")
      .find(".minus");
    var $cart_id = $(this)
      .parents(".num-block")
      .find(".minus")
      .attr("cart_id");
    // console.log(e.target.className);

    load_update($($click).attr("shop_id"), $input, $cart_id);
  }
});

$(".buttonBuyFinal").on("click", function(e) {
  if (validate()) {
    if (!$(this).hasClass("disabled")) {
      $(".buttonBuyFinal").addClass("disabled");
      load_buy();
    }
  }
});

$(".num-in span").click(function() {
  var $input = $(this)
    .parents(".num-block")
    .find("input.in-num");
  if ($(this).hasClass("minus")) {
    var count = parseFloat($input.val()) - 1;
    count = count < 1 ? 1 : count;
    if (count < 2) {
      $(this).addClass("dis");
    } else {
      $(this).removeClass("dis");
    }
    $input.val(count);
  } else {
    var count = parseFloat($input.val()) + 1;
    $input.val(count);
    if (count > 1) {
      $(this)
        .parents(".num-block")
        .find(".minus")
        .removeClass("dis");
    }
  }

  $input.change();
  return false;
});

$(".tsq_wrapper span").click(function() {
  var $input = $(this)
    .parents(".tickets__single__quantity")
    .find("input.in-num");

  if ($(this).hasClass("delete")) {
    var count = parseFloat($input.val()) - 1;
    count = count < 1 ? 1 : count;
    if (count < 2) {
      $(this).addClass("this");
    } else {
      $(this).removeClass("this");
    }
    $input.val(count);
  } else {
    var count = parseFloat($input.val()) + 1;
    $input.val(count);
    if (count > 1) {
      $(this)
        .parents(".tickets__single__quantity")
        .find(".delete")
        .removeClass("this");
    }
  }

  $input.change();
  return false;
});

$(".wti__wrapper span").click(function() {
  var $input = $(this)
    .parents(".wti__quantity")
    .find("input.in-num");
  var $input_id = $(this)
    .parents(".wti__quantity")
    .find("input.in-nums");

  if ($(this).hasClass("delete-widget")) {
    var count = parseFloat($input.val()) - 1;
    count = count < 1 ? 0 : count;
    if (count < 2) {
      $(this).addClass("this-widget");
    } else {
      $(this).removeClass("this-widget");
    }
    $input.val(count);
  } else {
    var count = parseFloat($input.val()) + 1;
    $input.val(count);

    console.log($input_id.val());
    if (wiGetCookie("symfony").length == 0) {
      // $(".sectionCartPopup").addClass("sectionCartPopupOpen");
      load_add_multiple_cookie($input_id.val(), $input.val());
    }
    if (count > 1) {
      $(this)
        .parents(".wti__quantity")
        .find(".delete-widget")
        .removeClass("this-widget");
    }
  }

  $input.change();
  return false;
});
